import { apiClient } from '../client';

export interface AreaOfStudy {
  _id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAreaOfStudyDto {
  name: string;
}

export interface UpdateAreaOfStudyDto {
  name?: string;
  isActive?: boolean;
}

export interface AreasOfStudyResponse {
  areas: AreaOfStudy[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const areasOfStudyAPI = {
  // Get all areas of study with pagination
  getAllAreasOfStudy: async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    activeOnly?: boolean;
  }): Promise<AreasOfStudyResponse> => {
    const response = await apiClient.get('/api/admin/areas-of-study', { params });
    return response.data;
  },

  // Get single area of study
  getAreaOfStudy: async (id: string): Promise<AreaOfStudy> => {
    const response = await apiClient.get(`/api/admin/areas-of-study/${id}`);
    return response.data;
  },

  // Create new area of study
  createAreaOfStudy: async (data: CreateAreaOfStudyDto): Promise<{ message: string; area: AreaOfStudy }> => {
    const response = await apiClient.post('/api/admin/areas-of-study', data);
    return response.data;
  },

  // Update area of study
  updateAreaOfStudy: async (id: string, data: UpdateAreaOfStudyDto): Promise<{ message: string; area: AreaOfStudy }> => {
    const response = await apiClient.put(`/api/admin/areas-of-study/${id}`, data);
    return response.data;
  },

  // Delete area of study
  deleteAreaOfStudy: async (id: string, permanent = false): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/api/admin/areas-of-study/${id}`, {
      params: { permanent },
    });
    return response.data;
  },

  // Search areas of study
  searchAreasOfStudy: async (query: string, limit = 20): Promise<{ areas: AreaOfStudy[]; count: number }> => {
    const response = await apiClient.get('/api/admin/areas-of-study/search', {
      params: { q: query, limit },
    });
    return response.data;
  },

  // Bulk create areas of study
  bulkCreateAreasOfStudy: async (names: string[]): Promise<{
    message: string;
    results: {
      created: string[];
      skipped: string[];
      errors: string[];
    };
  }> => {
    const response = await apiClient.post('/api/admin/areas-of-study/bulk', { names });
    return response.data;
  },
};
